import cookie from 'react-cookie';

const EXPERIMENT_SEPARATOR = '||';
const VARIANT_SEPARATOR = '::';


const EXP_COOKIE_NAME = '_wor_exp';

export function getExperimentCookieValue(experimentName) {
    const experimentsCookie = cookie.load(EXP_COOKIE_NAME) || '';
    const experimentStrings = experimentsCookie.split(EXPERIMENT_SEPARATOR);
    const experiments = experimentStrings.map((experimentString) => experimentString.split(VARIANT_SEPARATOR));
    const exp = experiments.find((experiment) => (experiment[0] === experimentName) );

    return exp ? exp[1] : undefined;
}

export function sellerDashboardEnabled() {
    return true;
}

export function reducedFeesEnabled() {
    const experimentReducedFeesValue = getExperimentCookieValue("reduced-fees-50-percent-discount");
    return !!experimentReducedFeesValue && (experimentReducedFeesValue.toLowerCase().startsWith("var_"));
}
